import { Button, Col, Flex, Row } from "antd";
import {
  workProcess1,
  workProcess2,
  workProcess3,
  workProcessBannerArrow,
} from "../../../assets";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Parallax, Pagination, Navigation } from "swiper/modules";
import WorkProcessStep from "./WorkProcessStep";

const WorkProcess = ({ content }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  return (
    <div className="section-content remove-bottom-padding">
      <div
        className="about-section-heading mobile-left-padding"
        data-aos="fade-right"
        data-aos-duration="700"
        data-aos-delay="100"
      >
        {content?.Heading}
      </div>
      <div
        className="section-heading mobile-left-padding"
        data-aos="fade-right"
        data-aos-duration="700"
        data-aos-delay="100"
      >
        {content?.Title}{" "}
      </div>
      {isMobile ? (
        <Swiper
          slidesPerView={1.3}
          style={{
            "--swiper-navigation-color": "#fff",
            "--swiper-pagination-color": "#fff",
          }}
          speed={600}
          parallax={true}
          modules={[Parallax, Pagination, Navigation]}
          className="mySwiper mobile-left-padding"
          spaceBetween={30}
        >
          <div
            slot="container-start"
            className="parallax-bg"
            style={{
              background: "#ffffff",
            }}
            data-swiper-parallax="-23%"
          ></div>
          {content?.WorkStep?.map((step, index) => {
            return (
              <SwiperSlide className="process-img" key={step.id}>
                <WorkProcessStep
                  processText={step.Description}
                  per={step.Percentage + "%"}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      ) : (
        <Row justify={"space-between"}>
          {content?.WorkStep?.map((step, index) => {
            return (
              <Col
                md={8}
                className="process-img"
                data-aos="fade-up"
                data-aos-duration="700"
                data-aos-delay="100"
                key={step.id}
              >
                <WorkProcessStep
                  processText={step.Description}
                  per={step.Percentage + "%"}
                />
              </Col>
            );
          })}
        </Row>
      )}
      <Row
        className="process-banner"
        justify={"center"}
        align={"center"}
        gutter={30}
        data-aos="fade-up"
        data-aos-duration="700"
        data-aos-delay="100"
      >
        <Col className="process-banner-text" style={{ textAlign: "center" }}>
          <span>Ready To Take Your</span>{" "}
          <span
            style={{
              color: "#4b3c5a",
              textShadow:
                "0px 0px 0 #ffffff, -1px -1px 0 #ffffff, 1px -1px 0 #ffffff, -1px 1px 0 #ffffff, 1px 1px 0 #ffffff",
            }}
          >
            Next Step
          </span>
        </Col>
        <Col>
          <Flex align="center">
            <Button shape="round" className="process-banner-btn">
              GET FREE CONSULTATION
            </Button>
            <div style={{ width: "40px", height: "40px" }}>
              <img src={workProcessBannerArrow} alt="send" className="p-img" />
            </div>
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
export default WorkProcess;
